import { defineComponent, ref, onMounted } from 'vue';
import HeaderCom from '@/components/HeaderCom.vue';
import ApplyCom from '@/components/applyCom.vue';
import FooterCom from '@/components/footerCom.vue';
import bg from '@/assets/img/banner/protocolProduct-banner.png';
import ModuleHeadCom from '@/components/moduleHeadCom.vue';
import AdvantageCom from './components/advantageCom.vue';
// import ApplicationScenario from './components/applicationScenario.vue'
import ProductFeatures from './components/productFeatures.vue';
import ProductInfo from './components/productInfo.vue';
import { wachtPageAni } from '@/uitl/currencyFunc.js';
export default defineComponent({
  components: {
    ProductInfo,
    ModuleHeadCom,
    AdvantageCom,
    ApplyCom,
    FooterCom,
    HeaderCom,
    // ApplicationScenario,
    ProductFeatures
  },
  setup() {
    const ProductFeatures = ref(null);
    const ApplicationScenario = ref(null);
    const AdvantageCom = ref(null);
    const ApplyCom = ref(null);
    onMounted(() => {
      wachtPageAni([ProductFeatures, ApplicationScenario, AdvantageCom, ApplyCom]);
    });
    return {
      ProductFeatures,
      ApplicationScenario,
      AdvantageCom,
      ApplyCom,
      BG: bg
    };
  }
});